import React from 'react';

import {
  Typography,
  PLATFORM_THEME_COLORS,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { FormWrapper, FormTitle, FormSubtitle } from '../../questionnaire-page.styles';

const QuestionnairePageFormWrapper = ({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
}) => {
  return (
    <FormWrapper>
      <FormTitle>
        <Typography
          fontColor={PLATFORM_THEME_COLORS.primary.black}
          weight={'bold'}
          size={TYPOGRAPHY_SIZE.large}
        >
          {title}
        </Typography>
      </FormTitle>
      <FormSubtitle>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{subtitle}</Typography>
      </FormSubtitle>
      {children}
    </FormWrapper>
  );
};

export default QuestionnairePageFormWrapper;
